import { NotebookIcon } from "@phosphor-icons/react/dist/csr/Notebook";
import { Badge } from "@volca/ui/components/ui/badge";
import { Button } from "@volca/ui/components/ui/button";
import { usePayPeriodNotes } from "./query";

export const PayrollNotesButton = ({
  businessId,
  periodStart,
  open,
  onOpen,
}: {
  businessId: string | null;
  periodStart: string;
  open: boolean;
  onOpen: () => void;
}) => {
  const notes = usePayPeriodNotes(businessId, periodStart);
  const count = notes.data?.openNotes.length ?? 0;
  const hasNotes =
    count > 0 ||
    (notes.data?.reviewedNotes.length ?? 0) > 0 ||
    (notes.data?.sentNotes.length ?? 0) > 0;

  if (!hasNotes && !notes.isError) return null;

  return (
    <Button
      variant="secondary"
      id="payroll-notes-trigger"
      aria-expanded={open}
      aria-controls="payroll-notes-panel"
      onClick={onOpen}
    >
      <NotebookIcon data-icon="inline-start" />
      Notes
      {count > 0 && (
        <Badge variant="secondary" color="warning" size="sm">
          {count}
        </Badge>
      )}
    </Button>
  );
};
